import { render } from "./HeaderView.vue?vue&type=template&id=1ddcf8cf&scoped=true"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import "./HeaderView.vue?vue&type=style&index=0&id=1ddcf8cf&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddcf8cf"]])

export default __exports__